import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NxWebComponentService {
  isWebComponentFlow = signal<boolean>(false);
  sinisterId = signal<string>('');
  formId = signal<number>(70);
  formDamageToEdit = signal<number | null>(null);
  isCancelEventTrigger = signal<boolean>(false);
  isCompleteEventTrigger = signal<boolean>(false);
  hasTokenExpired = signal<boolean>(false);

  constructor() {}
}
